import React, { useMemo } from 'react';
import CreatableSelect from 'react-select/creatable';
import { useSelector } from 'react-redux';
import { ucFirst } from '../../../../helpers/generic';
import { imageOption } from '../../../SelectComponents';

const emailRegex = /^(?=.{1,254}$)(?=.{1,64}@)[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;

export const normalizeRecipients = (recipients) => {
  if (!recipients) return [];
  if (Array.isArray(recipients)) {
    return recipients.map(r => (typeof r === 'string' ? r : r?.email)).filter(Boolean);
  }
  return [];
};

const RecipientsSelect = ({
  selectedEmails = [],
  onChange,
  isDisabled = false,
  placeholder = 'Select or type email(s)',
  className = 'flex-grow-1',
  classNamePrefix = 'select-component',
}) => {
  const users = useSelector(state => state.usersReducer.users) || [];

  const options = useMemo(() => {
    return users.map(u => ({
      value: u.email,
      label: ucFirst(u.name),
      image: u.profile_image,
      description: u.email,
    }));
  }, [users]);

  const value = useMemo(() => {
    return (selectedEmails || []).map(email => {
      const user = users.find(u => u.email === email);
      return user
        ? { value: email, label: ucFirst(user.name), image: user.profile_image, description: user.email }
        : { value: email, label: email };
    });
  }, [selectedEmails, users]);

  const handleChange = (vals) => {
    const emails = (vals || []).map(v => v.value).filter(v => emailRegex.test(v));
    onChange && onChange(emails);
  };

  return (
    <CreatableSelect
      isMulti
      isClearable
      options={options}
      value={value}
      onChange={handleChange}
      components={{ Option: imageOption }}
      placeholder={placeholder}
      className={className}
      classNamePrefix={classNamePrefix}
      isDisabled={isDisabled}
      formatCreateLabel={userInput => (emailRegex.test(userInput) ? `Add: ${userInput}` : `Invalid email: ${userInput}`)}
    />
  );
};

export default RecipientsSelect;